import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { ConnectedDeviceDefaultName, DeviceType, DeviceTypeEnum } from '../../models/enums/device-type.enum';

@Component({
    selector: 'web-device-type-label',
    templateUrl: './device-type-label.component.html',
    styleUrls: ['./device-type-label.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceTypeLabelComponent {
    type: InputSignal<DeviceType | undefined> = input<DeviceType>();
    surname: InputSignal<string | undefined> = input<string>();

    DeviceTypeEnum = DeviceTypeEnum;

    public isNameNotDefault(): boolean {
        if (!this.surname()) return false;
        if (!this.type()) return true;
        switch (this.type()) {
            case DeviceTypeEnum.PLAY:
                return this.surname() !== ConnectedDeviceDefaultName.PLAY;
            case DeviceTypeEnum.CITY:
                return this.surname() !== ConnectedDeviceDefaultName.CITY;
            case DeviceTypeEnum.STREAM_CONNECT:
                return this.surname() !== ConnectedDeviceDefaultName.STREAM_CONNECT;
            case DeviceTypeEnum.STOREY:
                return this.surname() !== ConnectedDeviceDefaultName.STOREY;
            case DeviceTypeEnum.ERL:
            case DeviceTypeEnum.ERL_GEN2:
                return false;
            case DeviceTypeEnum.STREAM_METER:
                return this.surname() !== ConnectedDeviceDefaultName.STREAM_METER;
            case DeviceTypeEnum.PLAY_MAX:
            default:
                return this.surname() !== ConnectedDeviceDefaultName.PLAY_MAX;
        }
    }
}
